import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=53f13d5e&"
import script from "./VehicleForm.vue?vue&type=script&lang=js&"
export * from "./VehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports